/* eslint-disable @typescript-eslint/no-explicit-any */
import cn from 'classnames';
import {FormikProps} from 'formik';
import {useNavigate} from 'react-router-dom';
import {IProductForm} from './productFormData';
import {useQueryClient} from 'react-query';

interface Props {
  image: string;
  title: string;
  count?: number;
  code?: number;
  form?: FormikProps<IProductForm>;
  isMain?: boolean;
}
export const InputGroupItem = ({
  image,
  title,
  count,
  code,
  form,
  isMain,
}: Props) => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  return (
    <div
      className={cn(
        `w-[76px] shadow-xs h-[90px] rounded-xl border-[1px] border-gray-300 flex flex-col items-center gap-1 justify-center`,
        form?.values.inputGroupCode === code &&
          !isMain &&
          'border-2 border-green-main',
        isMain && 'h-[105px]',
      )}
      onClick={() => {
        queryClient.removeQueries({queryKey: ['get-input-lists']});
        form?.setFieldValue('inputGuid', undefined);
        !isMain
          ? form?.setFieldValue('inputGroupCode', code)
          : navigate(`${code}`);
      }}
    >
      <div className="h-[50%] w-12">
        <img
          src={image}
          alt={title}
          className="object-contain h-full"
          loading="lazy"
        />
      </div>
      <span className="text-xs font-semibold text-gray-900">{title}</span>

      {isMain && <span className="text-sm text-gray-700">{count} مورد</span>}
    </div>
  );
};
